/**
 * @generated SignedSource<<1c76e652823b6ef76d4fe517e78bd6d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type UpdateRuleInputObject = {
  accountIds?: ReadonlyArray<string> | null | undefined;
  caseSensitive?: boolean | null | undefined;
  destinationBankAccountId?: string | null | undefined;
  direction?: string | null | undefined;
  enabled?: boolean | null | undefined;
  endDate?: any | null | undefined;
  expenseNatureId?: string | null | undefined;
  matchKind?: string | null | undefined;
  overrideTxnIds?: ReadonlyArray<string> | null | undefined;
  reattributeScope?: string | null | undefined;
  regex?: string | null | undefined;
  ruleId: string;
  stakeholderId?: string | null | undefined;
  stakeholderName?: string | null | undefined;
  startDate?: any | null | undefined;
  targetClassification?: TxnClassificationEnum | null | undefined;
};
export type rulesPage_UpdateRuleMutation$variables = {
  input: UpdateRuleInputObject;
};
export type rulesPage_UpdateRuleMutation$data = {
  readonly updateRule: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type rulesPage_UpdateRuleMutation = {
  response: rulesPage_UpdateRuleMutation$data;
  variables: rulesPage_UpdateRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rulesPage_UpdateRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRuleMutationPayload",
        "kind": "LinkedField",
        "name": "updateRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rulesPage_UpdateRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRuleMutationPayload",
        "kind": "LinkedField",
        "name": "updateRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "87285cb08587aee4099de4fe9fd8a405",
    "id": null,
    "metadata": {},
    "name": "rulesPage_UpdateRuleMutation",
    "operationKind": "mutation",
    "text": "mutation rulesPage_UpdateRuleMutation(\n  $input: UpdateRuleInputObject!\n) {\n  updateRule(input: $input) {\n    rule {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "548f46a007501f39eb0b1d601abdec48";

export default node;
